var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagebanner"},[_c('img',{attrs:{"src":_vm.urlObject[_vm.type]}})])
}
var staticRenderFns = []

export { render, staticRenderFns }